import "./input.css";
function Input(props) {
  return (
    <div className="form-input" style={{ ...props.style }}>
      <div className="label">
        <label>{props.label}</label>
      </div>
      <input
        className="main-style"
        name={props.name}
        onChange={props.handleInput}
        type={props.type}
        value={props.value}
        min={1}
        placeholder={props.placeholder}
      />
    </div>
  );
}

export default Input;
